import Vue from 'vue';

const success = (context, response) => {
  context.invoice = response.invoice;
  context.summaryRows = response.summaryRows;
  context.rentalsRows = response.rentalsRows;
  context.reservationsRows = response.reservationsRows;
  context.rentalOwner = response.owner;
  context.user = response.user;
};

const failed = (context, error) => {
  if(error.response && error.response.status === 404) {
      Vue.router.push({
        name: 'login.index',
      });
  }
};

export default (permalink, context) => {
  return Vue.$http.get(`superconciergerie/invoice-permalink/${permalink}`)
    .then(response => {
      success(context, response.data);
    }).catch(error => {
      failed(context, error);
    })
}



// WEBPACK FOOTER //
// ./src/app/services/superconciergerie/get-invoice-permalink.js